const Api = {
    '/api/sample-order/sample-audit-pass': 1, // 样品订单审核
    '/api/sample-order/sample-audit-refuse': 1, // 样品订单审核拒绝
    '/api/sample-order/batch-sample-audit-pass': 1, //样品订单批量审核通过
    '/api/sample-order/batch-sample-audit-refuse': 1, //样品订单批量审核拒绝
    '/api/sample-order/batch-refuse-deliver': 1, //样品订单批量审核拒绝发货
    '/api/sample-order/batch-deliver': 1, // 手动发货
}

export default{
    Api
}